export enum LoginStatus {
  Failed = 0,
  Success
}
